import styled from 'styled-components';
import { animated } from 'react-spring';
import { ArrowIcon } from '../Icons';
import { NumbersPopup } from '../Popup';
import { Button } from '../Button';
import { TextHint } from '../Hint';

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.diviserSmoothColor};
  border-radius: 10px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.text.placeholder};
  font-size: 1.2rem;
  line-height: 14px;
  border-width: 0;
  width: 100%;

  ${(props) => ({
    backgroundColor: props.isChecked ? props.theme.colors.ArrowIconUncheckColor.diviserSmoothColor : 'transparent',
    border: !props.isCollapsed && !props.isChecked ? '1px solid #eaeaea' : '0',
  })}

`;

export const Circle = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 9px;
  border: 1px solid ${(props) => props.theme.colors.secondary};
  display: inline-block;

  ${(props) => ({
    background: props.isChecked ? '#00bec1' : 'transparent',
    border: props.isChecked ? 0 : `1px solid ${(props) => props.theme.colors.secondary}`,
    visibility: !props.isBolded ? 'visible' : 'hidden',
  })}

`;

export const CircleWrapper = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  width: 20px;

  &:hover{
    background-color: transparent;
  }

`;

export const CircleItem = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 9px;
  border: 1px solid #6C6C6C;
  display: inline-block;
  margin-right: 5px;

  ${(props) => ({
    background: props.isChecked ? '#00bec1' : '#6C6C6C',
    border: props.isChecked ? 0 : '1px solid #6C6C6C',
  })}

`;

export const Arrow = styled(ArrowIcon)`
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;

  ${(props) => ({
    color: props.isChecked ? props.theme.colors.ArrowIconCheckColor : props.theme.colors.ArrowIconUncheckColor,
  })}

`;

export const Head = styled.div`
  padding: 5px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${(props) => props.theme.collapsibleOrderableList.itemHoverBackground};
    color: ${(props) => props.theme.collapsibleOrderableList.itemHoverColor};
    border-radius: 10px;
  }
`;

export const Collapser = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  overflow: hidden;
  align-items: center;
  display: inline-flex;
  color: inherit;

  &:hover{
    background-color: transparent;
  }
`;

export const TextBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;

  ${(props) => ({
    color: props.colored ? `${props.theme.colors.ItemCheckedColor} !important;` : 'inherit',
  })}
`;

export const TextGroup = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  overflow: hidden;
`;

export const Text = styled.div`
  &, p, span {
    color: ${(props) => props.theme.collapsibleOrderableList.textColor};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    // width: 85%;
    flex: 1;
  }
`;

export const TextWithHint = styled(TextHint)`
`;

export const TextOrder = styled.span`
  overflow: hidden;
  display: inline-block;
  margin-right: 1px;
`;

export const Title = styled(Text)`
  ${(props) => ({
    fontWeight: props.isBolded ? 'bold' : 'inherit',
  })}
  color: ${(props) => props.theme.collapsibleOrderableList.textTitle};
`;

export const Body = styled(animated.div)`  
  padding: 0px 20px;
  padding-bottom: 5px;
`;

export const Items = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
`;

export const Item = styled(Button)`
  cursor: pointer;
  width: calc(100% / 3);
  padding: 7px 7px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;

export const FixedItem = styled.div`
  width: calc(100% / 3);
  padding: 7px 7px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;

export const ArrowDown = styled(ArrowIcon)`
`;

export const NumbersBoxPopup = styled(NumbersPopup)`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: calc(100% / 3);

  .clickable {
    width: 100%;
  }
`;
